//#region components/avatar/avatar_constants.js
var e = {
	xs: "d-avatar--xs",
	sm: "d-avatar--sm",
	md: "d-avatar--md",
	lg: "d-avatar--lg",
	xl: "d-avatar--xl"
}, t = {
	default: "",
	icon: "d-avatar__icon",
	initials: "d-avatar__initials"
}, n = {
	md: "d-avatar__presence--md",
	lg: "d-avatar__presence--lg"
}, r = {
	NONE: "",
	BUSY: "busy",
	AWAY: "away",
	OFFLINE: "offline",
	ACTIVE: "active"
}, i = {
	xs: "100",
	sm: "200",
	md: "300",
	lg: "500",
	xl: "600"
}, a = [
	"000",
	"100",
	"200",
	"300",
	"400",
	"500",
	"600",
	"700",
	"800",
	"900",
	"1000",
	"1100",
	"1200",
	"1300",
	"1400",
	"1500",
	"1600",
	"1700",
	"1800"
], o = a.slice(1), s = (e) => e > 1, c = {
	AVATAR_SIZE_MODIFIERS: e,
	AVATAR_KIND_MODIFIERS: t,
	AVATAR_PRESENCE_SIZE_MODIFIERS: n,
	AVATAR_PRESENCE_STATES: r,
	AVATAR_ICON_SIZES: i,
	AVATAR_COLORS: a,
	AVATAR_RANDOM_COLORS: o,
	AVATAR_GROUP_VALIDATOR: s
};
//#endregion
export { a as AVATAR_COLORS, s as AVATAR_GROUP_VALIDATOR, i as AVATAR_ICON_SIZES, t as AVATAR_KIND_MODIFIERS, n as AVATAR_PRESENCE_SIZE_MODIFIERS, r as AVATAR_PRESENCE_STATES, o as AVATAR_RANDOM_COLORS, e as AVATAR_SIZE_MODIFIERS, c as default };

//# sourceMappingURL=avatar-constants.js.map